import { render, staticRenderFns } from "./SearcherByTradeName.vue?vue&type=template&id=49a16822&scoped=true&"
import script from "./SearcherByTradeName.vue?vue&type=script&lang=js&"
export * from "./SearcherByTradeName.vue?vue&type=script&lang=js&"
import style0 from "./SearcherByTradeName.vue?vue&type=style&index=0&id=49a16822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a16822",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a16822')) {
      api.createRecord('49a16822', component.options)
    } else {
      api.reload('49a16822', component.options)
    }
    module.hot.accept("./SearcherByTradeName.vue?vue&type=template&id=49a16822&scoped=true&", function () {
      api.rerender('49a16822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Customer/SearcherByTradeName.vue"
export default component.exports